<h2>Dale tu propia personalidad ¡ya!</h2>



<div class="contenedor_productos">
  <p>
    Escoge todo el producto que más te guste, la cantidad y el tamaño. Una vez que hayas terminado, da clic en "Comprar".
</p>
  <!-- === Taza Normal === -->
  <div class="producto">
    <ng-container *ngIf="onzaNormalSeleccionada; else imagenNormalPorDefecto">
      <img [src]="obtenerImagenNormal()" alt="Taza normal de {{ onzaNormalSeleccionada }} oz">
    </ng-container>
    <ng-template #imagenNormalPorDefecto>
      <img src="assets/imgProductospromocionales/taza_normal_11_oz.png" alt="Taza normal por defecto">
    </ng-template>
    <h3>Taza Normal</h3>
    <div class="descripcion">
      <p>Taza blanca personalizable</p>
    </div>
    <div class="menu-onzas-botones">
      <p><strong>Opciones:</strong></p>
      <button
        class="size-button"
        *ngFor="let onza of onzasNormales"
        [class.active]="onzaNormalSeleccionada === onza"
        (click)="seleccionarNormal(onza)">
        {{ onza }} oz ${{ preciosNormales[onza] }}
      </button>
    </div>
    <p *ngIf="onzaNormalSeleccionada">
      <strong>Precio: ${{ obtenerPrecioNormal() }}</strong>
    </p>
  </div>

  <!-- === Taza con Fondo de Color === -->
  <div class="producto">
    <ng-container *ngIf="onzaColorSeleccionada; else imagenColorPorDefecto">
      <img [src]="obtenerImagenColor()" alt="Taza color de {{ onzaColorSeleccionada }} oz">
    </ng-container>
    <ng-template #imagenColorPorDefecto>
      <img src="assets/imgProductospromocionales/taza_color_11_oz.png" alt="Taza Color por defecto">
    </ng-template>
    <h3>Taza con Fondo de Color</h3>
    <div class="descripcion">
      <p>Taza personalizable con colores de fondo</p>
    </div>
    <div class="menu-onzas-botones">
      <p><strong>Opciones:</strong></p>
      <button
        class="size-button"
        *ngFor="let onza of onzasColor"
        [class.active]="onzaColorSeleccionada === onza"
        (click)="seleccionarColor(onza)">
        {{ onza }} oz ${{ preciosColor[onza] }}
      </button>
    </div>
    <p *ngIf="onzaColorSeleccionada">
      <strong>Precio: ${{ obtenerPrecioColor() }}</strong>
    </p>
  </div>

  <!-- === Taza Mágica === -->
  <div class="producto">
    <ng-container *ngIf="onzaMagicaSeleccionada; else imagenMagicaPorDefecto">
      <img [src]="obtenerImagenMagica()" alt="Taza mágica de {{ onzaMagicaSeleccionada }} oz">
    </ng-container>
    <ng-template #imagenMagicaPorDefecto>
      <img src="assets/imgProductospromocionales/taza_magica_11_oz.png" alt="Taza Mágica por defecto">
    </ng-template>
    <h3>Taza Mágica</h3>
    <div class="descripcion">
      <p>Taza que revela la imagen con el calor</p>
    </div>
    <div class="menu-onzas-botones">
      <p><strong>Opciones:</strong></p>
      <button
        class="size-button"
        *ngFor="let onza of onzasMagicas"
        [class.active]="onzaMagicaSeleccionada === onza"
        (click)="seleccionarMagica(onza)">
        {{ onza }} oz ${{ preciosMagica[onza] }}
      </button>
    </div>
    <p *ngIf="onzaMagicaSeleccionada">
      <strong>Precio: ${{ obtenerPrecioMagica() }}</strong>
    </p>
  </div>

  <!-- === Productos Promocionales Adicionales === -->
  <div class="producto">
    <img src="assets/imgProductospromocionales/termos_.png" alt="Termos">
    <h3>Termos</h3>
    <div class="descripcion">
      <p>Termos personalizables</p>
    </div>
  </div>

  <div class="producto">
    <img src="assets/imgProductospromocionales/tequileros_.png" alt="Tequileros">
    <h3>Tequileros</h3>
    <div class="descripcion">
      <p>Tequileros personalizables</p>
    </div>
  </div>

  <div class="producto">
    <img src="assets/imgProductospromocionales/bolsas_.png" alt="Bolsas">
    <h3>Bolsas</h3>
    <div class="descripcion">
      <p>Bolsas personalizables</p>
    </div>
  </div>

  <div class="producto">
    <img src="assets/imgProductospromocionales/playeras_.png" alt="Playeras">
    <h3>Playeras</h3>
    <div class="descripcion">
      <p>Playeras personalizables</p>
    </div>
  </div>

  <div class="producto">
    <img src="assets/imgProductospromocionales/gorras_.png" alt="Gorras">
    <h3>Gorras</h3>
    <div class="descripcion">
      <p>Gorras personalizables</p>
    </div>
  </div>
</div>

<h2>¡Haz tu compra ya!</h2>

<div class="nota">
<p>una vez que le des clic en comprar y enviar nos comunicaremos contigo</p>
</div>

<div class="contenedor_botones">
  <button class="boton_compra">Comprar</button>
  <button class="boton_cancelar">Cancelar</button>
</div>

